import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RealEstateViewPageRoutingModule } from './realestate-view-routing.module';
import { RealEstateViewPage } from './realestate-view.component';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { RouterModule } from '@angular/router';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { PlaceholderCardFormVerticalComponent } from '@components/placeholders/card-form-vertical/card-form-vertical.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PreviewUploadImageComponent } from '@components/preview-upload-image/preview-upload-image.component';
import { ChipsModule } from 'primeng/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { InputNumberModule } from 'primeng/inputnumber';
import { EditorModule } from 'primeng/editor';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';

@NgModule({
  declarations: [
    RealEstateViewPage
  ],
  imports: [
    CommonModule,
    RealEstateViewPageRoutingModule,
    BackboneComponent,
    RouterModule,
    HeaderPageTitleBoxComponent,
    PlaceholderCardFormVerticalComponent,
    InputTextModule,
    ButtonModule,
    PreviewUploadImageComponent,
    ChipsModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    InputNumberModule,
    EditorModule,
    KeyFilterModule,
    ShowForPermissionsDirective
  ]
})
export class RealEstateViewPageModule { }
